import { createContext } from 'react';

import { DealBuilderContextValue } from './types';

export const dealBuilderContext = createContext<DealBuilderContextValue | null>(null);
